(function (root, factory) {
  'use strict';
  if (typeof module === 'object' && module.exports) { module.exports = factory; return; }
  if (root.CentralSportExpressCountdown) return;
  root.CentralSportExpressCountdown = factory(root);
})(typeof window !== 'undefined' ? window : globalThis, function createCountdown(runtime) {
  'use strict';

  // Consumidor de window.CentralSportExpressDelivery. Toda la lógica horaria, de corte y de
  // elegibilidad vive en el motor (getCutoffCountdown); aquí solo se formatea y se programa
  // el siguiente refresco, como máximo una vez por minuto.
  var ELEMENT = 'cs-express-countdown';
  var EVENT = 'cs:express-delivery:updated';
  var VARIANT_EVENT = 'maximize:variant-picker:updated:';
  var IDLE_DELAY = 60000;
  var MIN_DELAY = 250;
  var DELAY_BUFFER = 50;
  var ANNOUNCE_DELAY = 150;
  var DEFAULT_TEXT = {
    duration: 'Pide en las próximas {duration} y recíbelo en 24 horas',
    minutes: 'Pide en los próximos {duration} y recíbelo en 24 horas',
    oneHour: 'Pide en la próxima hora y recíbelo en 24 horas',
    lastMinute: 'Pide en el próximo minuto y recíbelo en 24 horas'
  };

  function parseTags(value) {
    try {
      var tags = JSON.parse(value || '[]');
      return Array.isArray(tags) ? tags : [];
    } catch (error) {
      return [];
    }
  }

  function readInput(element) {
    var dataset = element.dataset || {};
    return {
      product: { tags: parseTags(dataset.productTags), available: dataset.productAvailable === 'true' },
      variant: element.csVariant || { available: dataset.variantAvailable === 'true' }
    };
  }

  function plural(value, singular, pluralForm) {
    return value + ' ' + (value === 1 ? singular : pluralForm);
  }

  function formatDuration(hours, minutes) {
    var visual = [];
    var spoken = [];
    if (hours > 0) {
      visual.push(hours + ' h');
      spoken.push(plural(hours, 'hora', 'horas'));
    }
    if (minutes > 0) {
      visual.push(minutes + ' min');
      spoken.push(plural(minutes, 'minuto', 'minutos'));
    }
    return { visual: visual.join(' '), spoken: spoken.join(' y ') };
  }

  function textFor(element, key) {
    var dataset = (element && element.dataset) || {};
    var attribute = { duration: 'textDuration', minutes: 'textMinutes', oneHour: 'textOneHour', lastMinute: 'textLastMinute' }[key];
    return String(dataset[attribute] || DEFAULT_TEXT[key]);
  }

  function presentation(engine, input, element) {
    if (!engine || typeof engine.getCutoffCountdown !== 'function') {
      return { visible: false, status: 'engine_unavailable', delay: null };
    }
    if (!engine.config || engine.config.countdownEnabled !== true) {
      return { visible: false, status: 'disabled', delay: null };
    }
    try {
      var countdown = engine.getCutoffCountdown(input);
      if (!countdown || countdown.active !== true || countdown.status !== 'today') {
        return { visible: false, status: (countdown && countdown.status) || 'unknown', delay: IDLE_DELAY };
      }
      var totalMinutes = (countdown.hours * 60) + countdown.minutes;
      var delay = Math.max(MIN_DELAY, Number(countdown.nextUpdateMs || IDLE_DELAY) + DELAY_BUFFER);
      if (totalMinutes <= 1 || totalMinutes === 60) {
        var exact = textFor(element, totalMinutes === 60 ? 'oneHour' : 'lastMinute');
        return { visible: true, status: 'today', template: exact, duration: null, delay: delay };
      }
      return {
        visible: true,
        status: 'today',
        template: textFor(element, countdown.hours > 0 ? 'duration' : 'minutes'),
        duration: formatDuration(countdown.hours, countdown.minutes),
        delay: delay
      };
    } catch (error) {
      return { visible: false, status: 'error', delay: null };
    }
  }

  function splitTemplate(template) {
    var index = template.indexOf('{duration}');
    if (index === -1) return { before: template, after: '' };
    return { before: template.slice(0, index), after: template.slice(index + '{duration}'.length) };
  }

  function spokenText(result) {
    if (!result.visible) return '';
    var parts = splitTemplate(result.template);
    return result.duration ? parts.before + result.duration.spoken + parts.after : parts.before;
  }

  function buildLine(document, result) {
    var parts = splitTemplate(result.template);
    var nodes = [document.createTextNode(parts.before)];
    if (result.duration) {
      var time = document.createElement('strong');
      var visual = document.createElement('span');
      var spoken = document.createElement('span');
      time.className = 'cs-express-countdown__time';
      visual.setAttribute('aria-hidden', 'true');
      visual.textContent = result.duration.visual;
      spoken.className = 'cs-express-countdown__sr';
      spoken.textContent = result.duration.spoken;
      time.append(visual, spoken);
      nodes.push(time, document.createTextNode(parts.after));
    }
    return nodes;
  }

  // Mensaje vigente del componente que aloja la cuenta regresiva: la fila Express de «CS — Entrega»
  // o, si se reactiva, el bloque «CS — Entrega express».
  function benefitMessage(element) {
    if (typeof element.closest !== 'function') return '';
    var host = element.closest('[data-cs-express-countdown-host]');
    var selector = '[data-cs-express-countdown-message]';
    if (!host) {
      host = element.closest('cs-express-delivery-product-benefit');
      selector = '[data-cs-express-benefit-content]';
    }
    if (!host || host.hidden) return '';
    var content = host.querySelector(selector);
    if (!content || content.hidden) return '';
    return String(content.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function announce(element, text) {
    var announcer = element.querySelector('[data-cs-express-countdown-announcer]');
    if (!announcer || !runtime || typeof runtime.setTimeout !== 'function') return;
    if (element.csAnnounceTimer) runtime.clearTimeout(element.csAnnounceTimer);
    announcer.textContent = '';
    // Espera a que el bloque de beneficio procese el mismo evento antes de leer su mensaje.
    element.csAnnounceTimer = runtime.setTimeout(function () {
      element.csAnnounceTimer = null;
      announcer.textContent = typeof text === 'function' ? text() : text;
    }, ANNOUNCE_DELAY);
  }

  // Devuelve true cuando la cuenta regresiva aparece o desaparece.
  function render(element, options) {
    options = options || {};
    var line = element.querySelector('[data-cs-express-countdown-line]');
    var text = element.querySelector('[data-cs-express-countdown-text]');
    var result = presentation(runtime && runtime.CentralSportExpressDelivery, readInput(element), element);
    var previousVisible = element.csVisible;
    var changed = typeof previousVisible === 'boolean' && previousVisible !== result.visible;

    if (line) line.hidden = !result.visible;
    if (result.visible && text) {
      var key = result.template + '|' + (result.duration ? result.duration.visual : '');
      if (element.csRenderedKey !== key) {
        text.replaceChildren.apply(text, buildLine(runtime.document, result));
        element.csRenderedKey = key;
      }
    }
    element.csVisible = result.visible;
    element.dataset.csStatus = result.status;

    if (changed && options.announce !== false) {
      announce(element, result.visible ? spokenText(result) : function () { return benefitMessage(element); });
    }
    schedule(element, result.delay);
    return changed;
  }

  function schedule(element, delay) {
    if (!runtime || typeof runtime.setTimeout !== 'function') return;
    if (element.csTimer) runtime.clearTimeout(element.csTimer);
    element.csTimer = null;
    if (delay == null || !element.csListening) return;
    if (runtime.document && runtime.document.visibilityState === 'hidden') return;
    element.csTimer = runtime.setTimeout(function () { tick(element); }, delay);
  }

  function tick(element) {
    element.csTimer = null;
    var changed = render(element);
    var engine = runtime && runtime.CentralSportExpressDelivery;
    // Al cruzar el corte, avisa al resto de consumidores para que muestren el estado vigente.
    if (changed && engine && typeof engine.dispatchUpdate === 'function') {
      engine.dispatchUpdate({ reason: 'cs_express_countdown_state_changed' });
    }
  }

  function sectionIdFor(element) {
    var section = typeof element.closest === 'function' ? element.closest('[data-section-id]') : null;
    return section && section.dataset ? section.dataset.sectionId : '';
  }

  function register() {
    if (!runtime || !runtime.customElements || !runtime.HTMLElement || runtime.customElements.get(ELEMENT)) return;
    class Countdown extends runtime.HTMLElement {
      constructor() {
        super();
        this.csUpdate = () => render(this);
        this.csVisibility = () => {
          if (runtime.document.visibilityState === 'hidden') schedule(this, null);
          else tick(this);
        };
        this.csVariantChange = (event) => {
          var variant = event && event.detail && event.detail.currentVariant;
          this.csVariant = { available: Boolean(variant && variant.available) };
          render(this, { announce: false });
        };
      }
      connectedCallback() {
        if (this.csListening) return;
        this.csListening = true;
        this.csSectionId = sectionIdFor(this);
        runtime.document.addEventListener(EVENT, this.csUpdate);
        runtime.document.addEventListener('visibilitychange', this.csVisibility);
        if (this.csSectionId) runtime.document.addEventListener(VARIANT_EVENT + this.csSectionId, this.csVariantChange);
        render(this, { announce: false });
      }
      disconnectedCallback() {
        if (!this.csListening) return;
        runtime.document.removeEventListener(EVENT, this.csUpdate);
        runtime.document.removeEventListener('visibilitychange', this.csVisibility);
        if (this.csSectionId) runtime.document.removeEventListener(VARIANT_EVENT + this.csSectionId, this.csVariantChange);
        this.csListening = false;
        schedule(this, null);
        if (this.csAnnounceTimer) runtime.clearTimeout(this.csAnnounceTimer);
        this.csAnnounceTimer = null;
      }
    }
    runtime.customElements.define(ELEMENT, Countdown);
  }

  register();
  return Object.freeze({
    namespace: ELEMENT,
    presentation: presentation,
    formatDuration: formatDuration,
    spokenText: spokenText,
    render: render
  });
});
